import apiService from '../../../share/util/api/service';
import resource from '../../../share/util/resourceMap';
import { executePolling } from '../../../share/util/api/polling';
import { VEHICLE_UPDATE } from './constants';

/**
 * カスタマイズの設定値変更(要求)（バックエンドAPI_POST）のリクエストボディ生成
 * @param {object[]} items カスタマイズに表示されているデータリスト
 * @returns {{system_name: string[], settings: {system_name:string, settings: object[]}[]}} 
 */
export const getRequestBodyUpdateSettings = (items) => {
  return items.reduce((acc, cstm) => {
    const set = {
      immutable_id: cstm.immuTableId,
      currentValue: resource.getCstmSettingValue(cstm.currentValue, cstm.mapKeyToValue),
      isWriteRequired: cstm.currentValue === cstm.selectItem ? false : true,
      updateValue: resource.getCstmSettingValue(cstm.selectItem, cstm.mapKeyToValue),
      byte_value: (cstm.byteValue === undefined || cstm.byteValue === null) ? null : cstm.byteValue,
    };
    const targetIndex = acc.settings.findIndex((sys) => sys.system_name === cstm.systemId);
    if (targetIndex === -1) {
      acc.system_name.push(cstm.systemId);
      acc.settings.push({
        system_name: cstm.systemId,
        settings: [set]
      });
    } else {
      acc.settings[targetIndex].settings.push(set);
    }
    return acc;
  }, { system_name: [], settings: [] });
};

/**
 * カスタマイズ: カスタマイズデータ書き込みポーリング実行
 * @param {object} root 呼び出し元
 * @param {string} systemName システム名
 * @param {object} bodyParam POST時に設定するリクエストBody
 * @returns {Promise<object?>} 実行結果
 */
export const updateCustomizeTable = async (root, systemName, bodyParam) =>
  await executePolling(
    root,
    // POST API 呼び出しのコールバック
    async () => await apiService.postCall(
      apiService.CST,
      `/netApps/${root.netAppId}/systems/${systemName}/updateSettings`,
      bodyParam
    ),
    // GET API 呼び出しのコールバック
    async (postApiResponse) => await apiService.getCall(
      apiService.CST,
      `/netApps/${root.netAppId}/systems/${systemName}/customize/requests/${postApiResponse.data.request_id}`
    ),
    // エラー発生のコールバック
    (errorType) => { errorType; root.showUnexpectedError(VEHICLE_UPDATE); },
    // POST API レスポンスチェックのコールバックはデフォルト処理を使用
    undefined,
    // GET API レスポンスチェックのコールバックはデフォルト処理を使用
    undefined,
    // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { root.validateErrorResult(result, VEHICLE_UPDATE); },
    // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { root.validateErrorResult(result, VEHICLE_UPDATE); },
  );

export default {
  updateCustomizeTable,
};